import React, { Fragment, type FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { Button } from 'ic-snacks'
import { DashTooltip } from 'legacy/dash-blocks/dash-tooltip/DashTooltip'
import AisleVisibilityModals, {
  type AisleVisibilityModalProps,
} from 'legacy/routes/catalog/departments/aisleVisibility/AisleVisibilityModals'
import AisleVisibilityIcon from 'legacy/routes/catalog/departments/aisleVisibility/AisleVisibilityIcon'
import { useGetPrimaryProductsForAisle } from 'legacy/routes/catalog/departments/aisleVisibility/aisleVisibility.hooks'

interface Props extends AisleVisibilityModalProps {
  isAisleVisible: boolean
  handleOpenModal: () => void
  useMesh?: boolean
}

const AisleVisibilityCTA: FunctionComponent<Props> = ({
  aisleName,
  isAisleVisible,
  isModalOpen,
  setAisleVisibility,
  handleOpenModal,
  handleCloseModal,
  useMesh,
}) => {
  const { error, loading, hasPrimaryProducts } = useGetPrimaryProductsForAisle(useMesh)

  if (loading || error) {
    return (
      <Button
        elementAttributes={{ 'data-testid': 'aisle-visibility-disabled-cta' }}
        snacksStyle="flat"
        size="small"
        disabled
        icon={<AisleVisibilityIcon isAisleVisible={isAisleVisible} />}
      />
    )
  }

  return (
    <Fragment>
      <DashTooltip
        target={
          <Button
            elementAttributes={{ 'data-testid': 'aisle-visibility-cta' }}
            snacksStyle="flat"
            size="small"
            onClick={handleOpenModal}
            icon={<AisleVisibilityIcon isAisleVisible={isAisleVisible} />}
          />
        }
      >
        <span data-testid="aisle-visibility-tooltip">
          <FormattedMessage id={isAisleVisible ? 'aisles.tooltip.hide' : 'aisles.tooltip.show'} />
        </span>
      </DashTooltip>
      <AisleVisibilityModals
        isModalOpen={isModalOpen}
        hasPrimaryProducts={hasPrimaryProducts}
        aisleName={aisleName}
        isAisleVisible={isAisleVisible}
        setAisleVisibility={setAisleVisibility}
        handleCloseModal={handleCloseModal}
      />
    </Fragment>
  )
}

export default AisleVisibilityCTA
